export enum InterComponentCommKey {
    pageHeader = 'page header',
    previewPdf = 'preview pdf',
    newPurchaseOrderFormHeader = 'new po header',
    previewNewPurchaseOrder = 'preview new po',
    purchaseOrderBuilding = 'purchase order building',
    selectedContractorId = 'selected contractorId',
    allocationFacilityError = 'allocation facility error',
    hasABN = "has ABN",
    poType = "po type",
    isNewPO = "is new po",
    forReclassify = "for reclassification"
}
